export const mockTableData = [
  {
    ObjectId: "report-001",
    DateAdded: "2024-01-15T10:30:00Z",
    Status: "Completed",
    StatusColour: "#28a745",
    Recommendations: 12,
    CreatedBy: "John Doe"
  },
  {
    ObjectId: "report-002",
    DateAdded: "2024-01-20T14:45:00Z",
    Status: "In Progress",
    StatusColour: "#ffc107",
    Recommendations: 8,
    CreatedBy: "Jane Smith"
  },
  {
    ObjectId: "report-003",
    DateAdded: "2024-01-25T09:15:00Z",
    Status: "Pending",
    StatusColour: "#6c757d",
    Recommendations: 0,
    CreatedBy: "Bob Johnson"
  },
  {
    ObjectId: "report-004",
    DateAdded: "2024-02-01T16:20:00Z",
    Status: "Completed",
    StatusColour: "#28a745",
    Recommendations: 25,
    CreatedBy: "Alice Williams"
  }
];

